import { render, staticRenderFns } from "./EditChartLocalConfig.vue?vue&type=template&id=4122a312"
import script from "./EditChartLocalConfig.vue?vue&type=script&lang=js"
export * from "./EditChartLocalConfig.vue?vue&type=script&lang=js"
import style0 from "./EditChartLocalConfig.vue?vue&type=style&index=0&id=4122a312&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports